import { CompanyRole } from '../enums/company-role.enum';
import { InvitePortfolioDto } from './team.dto';

export enum TeamInviteState {
  VALID = 'valid',
  EXPIRED = 'expired',
  ACCEPTED = 'accepted',
  REVOKED = 'revoked',
}

/** What the accept page shows for an emailed invite link. */
export interface TeamInviteDetailsDto {
  state: TeamInviteState;
  companyName: string;
  inviterName: string;
  email: string;
  role: CompanyRole;
  /** The invitee had a seat here before and signs in with their existing account */
  rejoining: boolean;
  /** Portfolios they will work on as a collaborator */
  collaboratePortfolios: InvitePortfolioDto[];
}

export interface AcceptTeamInviteWithCredentialsDto {
  token: string;
  /** Required for a new account; ignored when an existing account rejoins */
  name?: string;
  password: string;
}

export interface AcceptTeamInviteWithGoogleDto {
  token: string;
  googleJwt: string;
}

/** An accept refused because the invite was spent, revoked or ran out meanwhile */
export const closedInviteErrorCodes = ['INVITE_EXPIRED', 'INVITE_REVOKED', 'INVITE_ACCEPTED'];
